// extracted by mini-css-extract-plugin
export default {"divider":"divider-module___divider___b2a252c6","horizontal":"divider-module___horizontal___dda22364","vertical":"divider-module___vertical___cdec2713"};